import React from "react";
import Video from "../../main/Video";
import BackButton from "../../main/BackButton";

const Collection1BagVideo = () => {
  return (
    <>
      <BackButton url="/allvideos" />
      <Video
        url={`https://yuriy-dmytrash19.wistia.com/medias/8ze8i0sl5s`}
        maxHeight="80%"
      />
    </>
  );
};

export default Collection1BagVideo;
